import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';


export abstract class ValidatorService {
  abstract getRowValidator(): FormGroup;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
